/*
    Imports the Roast API URL from the config.
*/

import apiCtrl from '@/services/api/abstract/abstract-api.js';
export default {
  getIPM: function(id, year, start = null, end = null) {
    let config = {};
    config.params = {
      start: start ? start : 1,
      end: end ? end : 12,
    };
    return apiCtrl.get('/contdb/ipm/' + id + '/year/' + year, config);
  },

  getGPM: function(id, year, start = null, end = null) {
    let config = {};
    config.params = {
      start: start ? start : 1,
      end: end ? end : 12,
    };
    return apiCtrl.get('/contdb/gpm/' + id + '/year/' + year, config);
  },

  getBPM: function(id, year, start = null, end = null) {
    let config = {};
    config.params = {
      start: start ? start : 1,
      end: end ? end : 12,
    };
    return apiCtrl.get('/contdb/bpm/' + id + '/year/' + year, config);
  },

  getGEI: function(id, year, start = null, end = null) {
    let config = {};
    config.params = {
      start: start ? start : 1,
      end: end ? end : 12,
    };
    return apiCtrl.get('/contdb/gei/' + id + '/year/' + year, config);
  },

  getCDG: function(id, year, start = null, end = null) {
    let config = {};
    config.params = {
      start: start ? start : 1,
      end: end ? end : 12,
    };
    return apiCtrl.get('/contdb/cdg/' + id + '/year/' + year, config);
  },

  getIGBT: function(id, year, start = null, end = null) {
    let config = {};
    config.params = {
      start: start ? start : 1,
      end: end ? end : 12,
    };
    return apiCtrl.get('/contdb/igbt/' + id + '/year/' + year, config);
  },
};
